import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import PatientIntegrationsAthena from 'common-src/models/PatientIntegrationsAthena';

import { InfoItem } from 'src/components/elements';
import BasePopup from 'src/popups/BasePopup';

import styles from './IntegrationAthenaDetailsPopup.module.scss';

const IntegrationAthenaDetailsPopup = ({ integration, onClose }) => (
  <BasePopup
    id="integration-athena-details"
    open
    onClose={onClose}
    title="Integration Athena Details"
  >
    <div className={styles.grid}>
      <InfoItem title="Practice ID" content={integration.practiceId} textId="practice-id" small />
      <InfoItem
        title="Athena Patient ID"
        content={integration.athenaPatientId}
        textId="athena-patient-id"
        small
      />
      <InfoItem title="Department" content={integration.department} textId="department" small />
    </div>
    <div className={[styles.grid, 'primary-border-t'].join(' ')}>
      <InfoItem
        title="Created"
        content={moment(integration.createdAt).format('MM/DD/YYYY')}
        textId="created-at"
        small
      />
      <InfoItem
        classNames={[styles.width75]}
        title="Created By"
        content={integration.createdBy?.getName(true, false)}
        textId="created-by"
        small
      />
    </div>
    <div className={[styles.grid, 'primary-border-t'].join(' ')}>
      <InfoItem
        title="Last Updated"
        content={moment(integration.updatedAt).format('MM/DD/YYYY')}
        textId="last-updated"
        small
      />
      <InfoItem
        classNames={[styles.width75]}
        title="Last Updated By"
        content={integration.updatedBy?.getName(true, false)}
        textId="updated-by"
        small
      />
    </div>
  </BasePopup>
);

IntegrationAthenaDetailsPopup.propTypes = {
  integration: PropTypes.exact(PatientIntegrationsAthena.schema),
  onClose: PropTypes.func,
};

export default IntegrationAthenaDetailsPopup;
